import React, { lazy, Suspense } from 'react'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import { usePageName } from '@/hooks/usePageData'

const Home = lazy(() => import('@/pages/Home'))
const About = lazy(() => import('@/pages/About'))
const Artists = lazy(() => import('@/pages/Artists'))
const ArtistDetail = lazy(() => import('@/pages/ArtistDetail'))
const Contact = lazy(() => import('@/pages/Contact'))
const ContactThankYou = lazy(() => import('@/pages/ContactThankYou'))
const LeaseEnquiry = lazy(() => import('@/pages/LeaseEnquiry'))
const ThankYou = lazy(() => import('@/pages/ThankYou'))
const Exhibitions = lazy(() => import('@/pages/Exhibitions'))
const ExhibitionDetail = lazy(() => import('@/pages/ExhibitionDetail'))
const Glossary = lazy(() => import('@/pages/Glossary'))
const Faq = lazy(() => import('@/pages/Faq'))
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'))
const TermsAndConditions = lazy(() => import('@/pages/TermsAndConditions'))
const Marketplace = lazy(() => import('@/pages/Marketplace'))
const ArtworkDetail = lazy(() => import('@/pages/ArtworkDetail'))
const Cart = lazy(() => import('@/pages/Cart'))
const CheckoutStart = lazy(() => import('@/pages/CheckoutStart'))
const CheckoutContact = lazy(() => import('@/pages/CheckoutContact'))
const CheckoutShipping = lazy(() => import('@/pages/CheckoutShipping'))
const CheckoutBilling = lazy(() => import('@/pages/CheckoutBilling'))
const CheckoutPayment = lazy(() => import('@/pages/CheckoutPayment'))
const OrderConfirmation = lazy(() => import('@/pages/OrderConfirmation'))
const OrderHistory = lazy(() => import('@/pages/OrderHistory'))
const SignIn = lazy(() => import('@/pages/SignIn'))
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'))
const PasswordReset = lazy(() => import('@/pages/PasswordReset'))
const SignOutSuccess = lazy(() => import('@/pages/SignOutSuccess'))
const Error404 = lazy(() => import('@/pages/Error404'))
const Error500 = lazy(() => import('@/pages/Error500'))

const PAGE_MAP: Record<string, React.LazyExoticComponent<React.ComponentType>> = {
  home: Home,
  about: About,
  artists: Artists,
  'artist-detail': ArtistDetail,
  contact: Contact,
  'contact-thank-you': ContactThankYou,
  'lease-enquiry': LeaseEnquiry,
  'thank-you': ThankYou,
  exhibitions: Exhibitions,
  'exhibition-detail': ExhibitionDetail,
  glossary: Glossary,
  faq: Faq,
  'privacy-policy': PrivacyPolicy,
  'terms-and-conditions': TermsAndConditions,
  marketplace: Marketplace,
  'artwork-detail': ArtworkDetail,
  cart: Cart,
  'checkout-start': CheckoutStart,
  'checkout-contact': CheckoutContact,
  'checkout-shipping': CheckoutShipping,
  'checkout-billing': CheckoutBilling,
  'checkout-payment': CheckoutPayment,
  'order-confirmation': OrderConfirmation,
  'order-history': OrderHistory,
  'sign-in': SignIn,
  'forgot-password': ForgotPassword,
  'password-reset': PasswordReset,
  'sign-out': SignOutSuccess,
  'error-404': Error404,
  'error-500': Error500,
}

export default function App() {
  const pageName = usePageName()
  const PageComponent = PAGE_MAP[pageName] ?? Home

  return (
    <div className="mig-app-root">
      <Header />
      {/* Main content - offset by sidebar and top nav. Responsive via CSS classes. */}
      <main className="mig-main-content">
        <Suspense fallback={null}>
          <PageComponent />
        </Suspense>
        <Footer />
      </main>
    </div>
  )
}
